
import PersistenceManagerDefault from "./default/PersistenceManager";
import PersistenceManagerAmbifi from "./ambifi/PersistenceManager";
import PersistenceManagerScorm1_2 from "./scorm1.2/PersistenceManager";
import PersistenceManagerScorm2004 from "./scorm2004/PersistenceManager";
import PersistenceManagerTinCan from "./tincan/PersistenceManager";

export default class PersistenceManagerFactory {

	static buildFromConfig(persistenceConfig = {}) {

		let persistenceManager;

		console.log("PERSISTENCE TYPE: " + persistenceConfig.type);

		switch (persistenceConfig.type) {
			case "ambifi":
				persistenceManager = new PersistenceManagerAmbifi(persistenceConfig);
				break;
			case "scorm1.2":
				persistenceManager = new PersistenceManagerScorm1_2(persistenceConfig);
				break;
			case "scorm2004":
				persistenceManager = new PersistenceManagerScorm2004(persistenceConfig);
				break;
			case "tincan":
				persistenceManager = new PersistenceManagerTinCan(persistenceConfig);
				break;
			default:
				persistenceManager = new PersistenceManagerDefault(persistenceConfig);
				break;
		}

		return persistenceManager;
	}






}